var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuoteMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "#EB6E46",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.286h6.857l-4.571 9.142h6.857l4.571-9.142V4.57H0v13.715zM18.285 4.571v13.715h6.857l-4.571 9.142h6.857l4.571-9.142V4.57H18.285z"
  })));
}

export default SvgQuoteMark;